module.exports = __webpack_public_path__ + "img/Registration_Welcome_Image_Mobile.c3932840.png";